import { render, staticRenderFns } from "./daily-cargo-identity-check-sheet.vue?vue&type=template&id=1ca9f4e2"
import script from "./daily-cargo-identity-check-sheet.vue?vue&type=script&lang=js"
export * from "./daily-cargo-identity-check-sheet.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-identity-check-sheet.vue?vue&type=style&index=0&id=1ca9f4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports